import { post, put, del } from "aws-amplify/api";
import { useMutation, useQueryClient } from "react-query";
import { fetchAuthSession } from "aws-amplify/auth";
import { PROFILE_DATA_QUERY_KEY } from "./useProfileQuery";

export const PostProfileMutation = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (profileFormInputs) => {
      const session = await fetchAuthSession();
      const { body } = await post({
        apiName: "pcmedapi",
        path: "/profile/about",
        options: {
          headers: {
            Authorization: session.tokens.idToken.toString(),
          },
          body: profileFormInputs,
        },
      }).response;
      return await body.json();
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [PROFILE_DATA_QUERY_KEY] });
    },
  });
};

export const PutProfileMutation = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (profileFormInputs) => {
      const session = await fetchAuthSession();
      const { body } = await put({
        apiName: "pcmedapi",
        path: "/profile/about",
        options: {
          headers: {
            Authorization: session.tokens.idToken.toString(),
          },
          body: profileFormInputs,
        },
      }).response;
      return await body.json();
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [PROFILE_DATA_QUERY_KEY] });
    },
  });
};

export const DeleteProfileMutation = () => {
  const queryClient = useQueryClient();
  return useMutation({
    retry: false,
    mutationFn: async () => {
      const session = await fetchAuthSession();
      const { body } = await del({
        apiName: "pcmedapi",
        path: "/profile/about",
        options: {
          headers: {
            Authorization: session.tokens.idToken.toString(),
          }
        },
      }).response;
      return await body.json();
    },
    onSuccess: () => {
      queryClient.clear();
    },
  });
};
